//own imports
import './manegePeople.css';
import LoadingGif from '../../../images/LoadingGif.gif';
//imports react
import React, {
    useEffect,
    useState,
    useRef,
} from 'react';
import 'react-tiny-fab/dist/styles.css';
import * as FaIcons from 'react-icons/fa';
import {
    useParams, 
} from "react-router-dom";
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import QrReader from 'react-qr-reader'
import ReactDOM from 'react-dom';

//firebase imports
import { collection, query, where, getDocs, getDoc, doc, Timestamp, addDoc, arrayRemove, updateDoc, arrayUnion} from "firebase/firestore";
import { getFirestore } from "firebase/firestore";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { ToggleSwitch } from '../../common';

const Operation = {
    AddRemoveMemersFromGroup: 'AddRemoveMemersFromGroup',
    EditRemoveGroup: 'EditRemoveGroup',
    //EditOthersPermissions: 'EditOthersPermissions',
    CreateRemoveGroupCategories: 'CreateRemoveGroupCategories',
    EditRemoveOtherTheirExpenses: 'EditRemoveOtherTheirExpenses'
};

const db = getFirestore();
const auth = getAuth();

const ManagePeople = () => {

    const [currentUser, setCurrentUser] = useState(null);
    const [members, setMembers] = useState([]);

    //scan
    const [canScan, setCanScan] = useState(false);
    const [scannedUserName, setScannedUserName] = useState(null);
    const [scannedUser, setScannedUser] = useState(null);

    const qrRef = useRef(null);
    //popup
    const popUpRef = useRef(null);
    const openPopup = () => popUpRef.current.open(); const closePopup = () => popUpRef.current.close();

    //checkbox states
    const handleErrorQr = (error) => {
        document.getElementsByClassName('qr-errorMessage').innerHTML = error;
    }

    async function handleScanQr (result) {
        //RESULT zou een id van een user gekend op het systeem moeten terug geven
        let getUserNameFromFireBase = [];

        if(result !== null){
            const q = query(collection(db, "Users"), where("userId", "==", result));

            const querySnapshot = await getDocs(q);
            querySnapshot.forEach((doc) => {
                // doc.data() is never undefined for query doc snapshots
                getUserNameFromFireBase.push({ ...doc.data() });
            });
            if (getUserNameFromFireBase.length >= 1) {
                //open popup

                openPopup();
                cancelScan();
                setScannedUserName(getUserNameFromFireBase[0].userName);
                setScannedUser(getUserNameFromFireBase[0]);
            }
            else {
                document.getElementsByClassName('qr-errorMessage')[0].innerHTML = 'No user found with this QR code: ' + result;

            }
        }
        else{
            document.getElementsByClassName('qr-errorMessage')[0].innerHTML = 'No QR code found';


        }
        //alert(result + "UID");
    }

    //retrieving params from url
    const { groupId } = useParams();

    //Page title
    useEffect(() => {

        document.title = 'Manage Members';

        onAuthStateChanged(auth, (user) => {
            if (user !== null) {
                setCurrentUser(user);
            }
        });
        getCurrentUser();
        getAllMembersFromGroup();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (members.length === 0) {
        return (
            <div className='headBoxManagePeople' style={{ minHeight: '100vh' }} >
                <div style={{ maxWidth: '1200px', width:'100%' }}>
                    <p className='errorMessage'></p>

                <h1 className="header">Manage Members</h1>
                <p className="membersSubTitle">Members</p>
                <div className="loading-gif-container">
                    <img src={LoadingGif} alt="loading" />
                </div>
                <div className="searchMemeberBox">
                    <div className="addMemberQR">
                        <p className="membersSubTitle">Scan the QR-code from the user you want to add</p>
                        <button className='btn-primary startScan' onClick={scanUserQrCode}>Scan User</button>

                            <div className='qrPlaceholder'></div>

                            <p className='errorMessage qr-errorMessage'></p>
                            <button className='cancelScan btn-secondary' onClick={cancelScan} style={{ display: 'none' }}>Cancel Scan</button>
                    </div>
                </div>
                <div className="searchMemeberBox">
                    <div className="addMemberSearch">
                        <p className="membersSubTitle">Search an member by username</p>
                        <p className="errorMessage errorMemberMessage"></p>
                        <input type="text" className="searchBarMember" placeholder="Search..." /> <br />
                        <button className="btn-primary " onClick={addMemberSearch}>Add Member</button>
                    </div>
                </div>
                <button className="btn-secondary" onClick={goBack}>Back</button>
            </div>
                <Popup ref={popUpRef} modal>
                    <div className="contenpopupcontainer">
                        <div className="scanPopUpContent" style={{ margin: '1.5rem' }}>
                            <h2 style={{ fontSize: '2rem', marginBottom: '1rem', textAlign: 'center' }} >User</h2>
                            <span>Name: </span><p className='userScanName' style={{ fontSize: '1.4rem', marginBottom: '0.8rem' }} >{scannedUserName}</p>
                            <p className='errorMessage errorAddScanned'></p>
                        </div>
                        <div className="actionPopUpScan">
                            <button className='btn-primary' onClick={addScannedMember}>Add User</button>
                            <button className='btn-secondary' onClick={closePopup} >Cancel</button>
                        </div>
                    </div>
                </Popup>
            </div>
        );
    }
     else { 
        return (
            <div className='headBoxManagePeople' style={{ minHeight: '100vh' }}>
                <div style={{ maxWidth: '1200px', width:'100%' }}>
                    <p className='errorMessage'></p>
                <h1 className="header">Manage Members</h1>
                <p className="membersSubTitle">Members</p>
                <div className="allMembers">
                    {members.map((member, index) => {
                        return (
                            <div className="member" key={index}>
                                <div className="memberInfo memberSub">
                                    <div className="member-name">{member.name}{member.id === currentUser.uid? <span style={{color: 'darkslategray', fontStyle: 'italic'}}><small>(you)</small></span>: <div></div>} </div>
                                    <div className="member-email">{member.email}</div>
                                    <div className="member-role">{member.role}</div>
                                </div>
                                <div className="member-actions memberSub">
                                    <div className="member-action">
                                        <Popup trigger={<div><FaIcons.FaEdit color="rgb(202, 202, 202)" size={25} ></FaIcons.FaEdit></div>} position="center" modal>
                                            {close => (
                                                <div className="popUpDeleteGroup">
                                                    <div className="popUpDeleteGroup_header"> Edit Member: {member.name}</div>
                                                    <div className="popUpDeleteGroup_content">
                                                        <div className="memberPermissions_title">Member Permissions</div>
                                                        <div className="memberPermissions">
                                                            <div className="permission">
                                                                <span>Add or Remove <strong>Members</strong> of this group</span>  <ToggleSwitch isChecked={member.permissions[0].AddRemoveMemersFromGroup} className="AddRemoveMemersFromGroup"></ToggleSwitch>
                                                            </div>
                                                            <div className="permission">
                                                                <span>Edit this <strong>Group</strong></span> <ToggleSwitch isChecked={member.permissions[0].EditRemoveGroup} className="EditRemoveGroup"></ToggleSwitch>
                                                            </div>
                                                            {/*<div className="permission">
                                                                <span>Edit <strong>Permissions</strong> from Members in this group</span> <ToggleSwitch isChecked={member.permissions[0].EditOthersPermissions} className="EditOthersPermissions"></ToggleSwitch>
                                                            </div>*/}
                                                            <div className="permission">
                                                                <span>Edit <strong>Categories</strong> of this group</span> <ToggleSwitch isChecked={member.permissions[0].CreateRemoveGroupCategories} className="CreateRemoveGroupCategories"></ToggleSwitch>
                                                            </div>
                                                            <div className="permission">
                                                                <span>Edit <strong>Expenses</strong> of other Members in this group</span> <ToggleSwitch isChecked={member.permissions[0].EditRemoveOtherTheirExpenses} className="EditRemoveOtherTheirExpenses"></ToggleSwitch>
                                                            </div>
                                                        </div>
                                                        <p className="errorMessage updateMemberException"></p>
                                                    </div>
                                                    <div className="popUpDeleteGroup_actions">
                                                        <button className="btn-secondary btnCancel" onClick={() => { close(); }}>Cancel</button>
                                                        <button className="btn-primary" onClick={() => updateMember(member)}>Update Member</button>
                                                        {member.role.includes('Admin') ? <button className="btn-danger" onClick={() => removeAdmin(member)}>Remove Admin</button> : <div></div>}
                                                        {member.role.includes('Member') ? <button className="btn-primary" onClick={() => addAdmin(member)}>Add Admin</button> : <div></div>}
                                                    </div>
                                                </div>
                                            )}
                                        </Popup>
                                    </div>
                                    <div className="member-action">
                                       {member.id === currentUser.uid? <div></div>
                                       :
                                            <Popup trigger={<div><FaIcons.FaTrash color="rgb(202, 202, 202)" size={25} /></div>} position="center" modal>
                                                {close => (
                                                    <div className="popUpDeleteGroup">
                                                        <div className="popUpDeleteGroup_header"> Delete Member: {member.name} </div>
                                                        <div className="popUpDeleteGroup_content">
                                                            <p>Are you sure to delete this member?</p>
                                                            <p className="errorMessage deleteMemberException"></p>
                                                        </div>
                                                        <div className="popUpDeleteGroup_actions">
                                                            <button className="btn-secondary btnCancel" onClick={() => { close(); }}>Cancel</button>
                                                            <button className="btn-danger" onClick={() => deleteMember(member)}>Delete Member</button>
                                                        </div>
                                                    </div>
                                                )}
                                            </Popup>}
                                    </div>
                                </div>
                            </div>
                        );
                    })
                    }
                </div>
                <div className="searchMemeberBox">
                    <div className="addMemberQR">
                        <p className="membersSubTitle">Scan the QR-code from the user you want to add</p>
                            <button className='btn-primary startScan' onClick={scanUserQrCode}>Scan User</button>

                            <div className='qrPlaceholder'></div>

                            <p className='errorMessage qr-errorMessage'></p>
                            <button className='cancelScan btn-secondary' onClick={cancelScan} style={{ display: 'none' }}>Cancel Scan</button>
                    </div>
                </div>
                <div className="searchMemeberBox">
                    <div className="addMemberSearch">
                        <p className="membersSubTitle">Search an member by username</p>
                        <p className="errorMessage errorMemberMessage"></p>
                        <input type="text" className="searchBarMember" placeholder="Search..." /> <br />
                        <button className="btn-primary" onClick={addMemberSearch}>Add Member</button>
                    </div>
                </div>
                <button className="btn-secondary" style={{marginTop:'2rem'}} onClick={goBack}>Back</button>
            </div>
                <Popup ref={popUpRef} modal>
                    <div className="contenpopupcontainer">
                        <div className="scanPopUpContent" style={{margin:'1.5rem'}}>
                            <h2 style={{fontSize:'2rem', marginBottom:'1rem', textAlign:'center'}} >User</h2>
                            <span style={{ fontSize: '1.4rem', marginBottom: '0.8rem' }}>Name: </span><span className='userScanName' style={{ fontSize: '1.4rem', marginBottom: '0.8rem' }} >{scannedUserName}</span>
                            <p className='errorMessage errorAddScanned'></p>
                        </div>
                        <div className="actionPopUpScan">
                            <button className='btn-primary' onClick={addScannedMember}>Add User</button>
                            <button className='btn-secondary' onClick={closePopup} >Cancel</button>
                        </div>
                    </div>
                </Popup>
            </div>
        );
    }


    function cancelScan(){
        setCanScan(false);
        document.getElementsByClassName('qrScanner')[0].style.display = 'none';
        document.getElementsByClassName('cancelScan')[0].style.display = 'none';
        document.getElementsByClassName('startScan')[0].style.display = 'inline-block';
    }

    function scanUserQrCode(){
        ReactDOM.render(
        <QrReader 
            className='qrScanner' 
            ref={qrRef} 
            delay={canScan} 
            style={{ width: '85%', maxWidth: '500px', display: 'none', margin: '1rem' }} 
            onScan={handleScanQr} 
            onError={handleErrorQr} 
            facingMode='environment' />,
             document.getElementsByClassName('qrPlaceholder')[0]);

        setCanScan(300);
        document.getElementsByClassName('qrScanner')[0].style.display = 'inline-block';
        document.getElementsByClassName('cancelScan')[0].style.display = 'inline-block';
        document.getElementsByClassName('startScan')[0].style.display = 'none';
    }

    async function removeAdmin(member) {
        const updateErrorMessage = document.querySelector('.updateMemberException');
        //only owner or the admin himself kan remove the admin role
       try {
           const groupDocSnapshot = await getDoc(doc(db, "Groups", groupId));

           if (groupDocSnapshot.data().owner === currentUser.uid || (groupDocSnapshot.data().admins.includes(currentUser.uid) && currentUser.uid === member.id)) {
               await updateDoc(doc(db, "Groups", groupId), {
                   admins: arrayRemove(member.id)
               }).then(() => {
                   updateDoc(doc(db, "Groups", groupId, "Members", member.key), {
                       permissions: [{ AddRemoveMemersFromGroup: false, EditRemoveGroup: false, EditOthersPermissions: false, CreateRemoveGroupCategories: false, EditRemoveOtherTheirExpenses: false }]
                   }).then(() => {
                       window.location.reload();
                   });
               }).catch(err => { updateErrorMessage.innerHTML = err.message });
           }
           else {
               updateErrorMessage.innerHTML = "Only the owner or the user himself can remove the admin role";
           }
       } catch (error) {
           updateErrorMessage.innerHTML = "Could not remove admin role" + error.message;
       }
    }

    async function addAdmin(member) {
        const updateErrorMessage = document.querySelector('.updateMemberException');

        const groupDocSnapshot = await getDoc(doc(db, "Groups", groupId));

       try {
           //only owner and admins can add admins
           if (groupDocSnapshot.data().owner === currentUser.uid || groupDocSnapshot.data().admins.includes(currentUser.uid)) {
               await updateDoc(doc(db, "Groups", groupId), {
                   admins: arrayUnion(member.id)
               }).then(() => {
                   //zorgen als je admin wordt dat je alle rechten krijgt
                   updateDoc(doc(db, "Groups", groupId, "Members", member.key), {
                       permissions: [{ AddRemoveMemersFromGroup: true, EditRemoveGroup: true, EditOthersPermissions: true, CreateRemoveGroupCategories: true, EditRemoveOtherTheirExpenses: true }]
                   }).then(() => {
                       window.location.reload();
                   });
               })
                   .catch(err => { updateErrorMessage.innerHTML = err.message });
           }
           else {
               updateErrorMessage.innerHTML = "Only owner and admins can add admins";
           }
       } catch (error) {
           updateErrorMessage.innerHTML = "Couldn't add the member as an admin: " + error.message;
       }
    }

    function goBack(){
        window.history.back();
    }

    //kijken of de ingelogde gebruiker permissie heeft om memebers, te gaan verwijde, updaten, ... 
    function checkPermissions(operation){
        let memberPermissions;
        members.forEach(member => {
            if(member.id === currentUser.uid){
                memberPermissions = member.permissions[0];
            }
        });
        if(operation === Operation.AddRemoveMemersFromGroup){
            if(memberPermissions.AddRemoveMemersFromGroup){
                return true;
            }
            return false;
        }
        //zal hier niet gebeuren
        else if (operation === Operation.EditRemoveGroup){
            if (memberPermissions.EditRemoveGroup) {
                return true;
            }
            return false;
        }
        //wel
        else if (operation === Operation.EditOthersPermissions){
            if (memberPermissions.EditOthersPermissions) {
                return true;
            }
            return false;
        }
        //zal hiet niet gebeuren
        else if (operation === Operation.CreateRemoveGroupCategories){
            if (memberPermissions.CreateRemoveGroupCategories) {
                return true;
            }
            return false;
        }
        //zal hier niet gebeuren
        else if (operation === Operation.EditRemoveOtherTheirExpenses){
            if (memberPermissions.EditRemoveOtherTheirExpenses) {
                return true;
            }
            return false;
        }
        return false;
    }

    async function getAllMembersFromGroup(){
        try {
        const getMembersFromFirebase =[];
        const members = [];
        const queryGroup = query(collection(db, "/Groups", groupId, "Members"));
        const queryGroupSnapshot = await getDocs(queryGroup);
        queryGroupSnapshot.forEach((doc) => {
            // doc.data() is never undefined for query doc snapshots
            //only users where the memberschip is greater than today
            if (new Date(doc.data().membership.seconds *1000) > new Date()){
                members.push({ ...doc.data(),key: doc.id, membership: new Date(doc.data().membership.seconds * 1000), enteredGroup: new Date(doc.data().enteredGroup.seconds * 1000) });
            }
        });


        for (let index = 0; index < members.length; index++) {
            const element = members[index];
            const queryMemberName = query(collection(db, "/Users"), where("userId", "==", element.uid));
            const queryMemberNameSnapshot = await getDocs(queryMemberName);
            queryMemberNameSnapshot.forEach((doc2) => {
                getMembersFromFirebase.push({ id: element.uid, key: element.key, value: doc2.data().userName, name: doc2.data().userName, enteredGroup: element.enteredGroup, membership: element.membership, selected: false, permissions: element.permissions, role: ""});
            });
        }


          const groupDoc = await getDoc(doc(db, "/Groups", groupId));

          getMembersFromFirebase.forEach(member => {
              if (groupDoc.data().owner === member.id && groupDoc.data().admins.includes(member.id)) {
                  member.role = "Owner & Admin";
              }
              else if (groupDoc.data().admins.includes(member.id)) {
                  member.role = "Admin";
              }
              else if (groupDoc.data().owner === member.id) {
                  member.role = "Owner";
              }
              else {
                  member.role = "Member";
              }

          });
            setMembers(getMembersFromFirebase);
      } catch (error) {
          document.getElementsByClassName('errorMessage')[0].innerHTML = "Could not retrieve data" + error.message;
      }


    }
    async function deleteMember(member){
        const deleteMessage = document.querySelector(".deleteMemberException");
        if (checkPermissions(Operation.AddRemoveMemersFromGroup)) {
            try {
                let docId = null;
                const memberDocs = await query(collection(db, "Groups", groupId, "Members"), where("uid", "==", member.id));
                const memberDocSnapshot = await getDocs(memberDocs);
                memberDocSnapshot.forEach((doc) => {
                    docId = doc.id;
                });
                deleteMessage.innerHTML = "";
                //kijken naar de admin id van de groep, gelijk aan de user die je wilt verwijderen dan kan je deze niet verwijderen.
                const groupDocSnapshot = await getDoc(doc(db, "Groups", groupId));
                if (groupDocSnapshot.exists()) {
                    if (groupDocSnapshot.data().owner === member.id || groupDocSnapshot.data().admins.includes(member.id)) {
                        deleteMessage.innerHTML = "You can't delete the admin or the owner of the group";
                        return;
                    }
                }

                //zoeken naar uid in de memberIds van de groep
                await updateDoc(doc(db, "Groups", groupId), { members: arrayRemove(member.id) });

                await updateDoc(doc(db, "Groups", groupId, "Members", docId), {
                    membership: Timestamp.fromDate(new Date()),
                }).then(() => {
                    window.location.reload();
                });
            } catch (e) {
                deleteMessage.innerHTML = "Something went wrong, please try again later " + e;
            }
        }
        else{
            deleteMessage.innerHTML = "You don't have the permissions to delete this member";
        }
    }

    async function  updateMember(member){
        const memberMessage = document.getElementsByClassName("updateMemberException")[0];
       try {
           //admins and owner can do this.
           let canEditPermissions = false;
           const groupDoc = await getDoc(doc(db, "/Groups", groupId));
           if (groupDoc.exists()) {
               if (groupDoc.data().owner === currentUser.uid || groupDoc.data().admins.includes(currentUser.uid)) {
                   canEditPermissions = true;
               }
           }

           if (canEditPermissions) {
               const toggleEditMembers = document.getElementsByClassName("AddRemoveMemersFromGroup")[0];
               const toggleEditGroup = document.getElementsByClassName("EditRemoveGroup")[0];
               //const toggleEditOthersPermissions = document.getElementsByClassName("EditOthersPermissions")[0];
               const toggleEditCategories = document.getElementsByClassName("CreateRemoveGroupCategories")[0];
               const toggleEditExpenses = document.getElementsByClassName("EditRemoveOtherTheirExpenses")[0];

               memberMessage.innerHTML = "";

               try {

                   const groupDocSnapshot = await getDoc(doc(db, "Groups", groupId));
                   if (groupDocSnapshot.exists()) {
                       if (groupDocSnapshot.data().owner === member.id || groupDocSnapshot.data().admins.includes(member.id)) {
                           memberMessage.innerHTML = "You can't update the admin or the owner permissions";
                           return;
                       }
                   }

                   await updateDoc(doc(db, "Groups", groupId, "Members", member.key), {
                       permissions: [{
                           AddRemoveMemersFromGroup: toggleEditMembers.checked,
                           EditRemoveGroup: toggleEditGroup.checked,
                           //EditOthersPermissions: toggleEditOthersPermissions.checked,
                           CreateRemoveGroupCategories: toggleEditCategories.checked,
                           EditRemoveOtherTheirExpenses: toggleEditExpenses.checked
                       }]
                   }).then(() => {
                       window.location.reload();
                   });
               } catch (error) {
                   memberMessage.innerHTML = "Something went wrong, please try again later " + error;
               }
           }
           else {
               memberMessage.innerHTML = "You don't have the permissions to edit this member permissions";
           }
       } catch (error) {
           memberMessage.innerHTML = "A problem occured while updating the member" + error;
       }
    }

    async function addMemberSearch(){
        const searchBarMember = document.getElementsByClassName("errorMemberMessage")[0];

        try {
            if (checkPermissions(Operation.AddRemoveMemersFromGroup)) {
                let userAlredyExists = false;
                let userExistsButMemberschipIsNotValid = false;
                let allMembers = [];
                try {

                    const queryGroup = query(collection(db, "/Groups", groupId, "Members"));
                    const queryGroupSnapshot = await getDocs(queryGroup);
                    queryGroupSnapshot.forEach((doc) => {
                        // doc.data() is never undefined for query doc snapshots
                        //only users where the memberschip is greater than today
                        allMembers.push({ ...doc.data(), membership: new Date(doc.data().membership.seconds * 1000), enteredGroup: new Date(doc.data().enteredGroup.seconds * 1000), key: doc.id });
                    });

                    const getMembersFromFirebase = [];
                    const queryMemberName = query(collection(db, "/Users"), where("userName", "==", document.getElementsByClassName("searchBarMember")[0].value));
                    const queryMemberNameSnapshot = await getDocs(queryMemberName);
                    queryMemberNameSnapshot.forEach((doc2) => {
                        getMembersFromFirebase.push({ userId: doc2.data().userId, membership: doc2.data().membership, key: doc2.id });
                    });

                    if (getMembersFromFirebase.length <= 0) {
                        searchBarMember.innerHTML = "This user doesn't exist";
                        document.getElementsByClassName("searchBarMember")[0].value = "";
                    }
                    else {
                        allMembers.forEach((member) => {
                            getMembersFromFirebase.forEach((memberFromFirebase) => {
                                if (member.uid === memberFromFirebase.userId && new Date(member.membership) > new Date()) {
                                    userAlredyExists = true;
                                    searchBarMember.innerHTML = "This user is already in this group";
                                    document.getElementsByClassName("searchBarMember")[0].value = "";
                                    return;
                                }
                                else if (member.uid === memberFromFirebase.userId && new Date(member.membership) <= new Date()) {
                                    userExistsButMemberschipIsNotValid = true;
                                    memberFromFirebase.key = member.key;
                                }
                            });
                        });

                        if (userAlredyExists === false) {
                            if (!userExistsButMemberschipIsNotValid) {
                                try {
                                    await getMembersFromFirebase.forEach((member) => {
                                        updateDoc(doc(db, "Groups", groupId), { members: arrayUnion(member.userId) });
                                        const addMember = addDoc(collection(db, "Groups", groupId, "Members"), {
                                            uid: member.userId,
                                            membership: Timestamp.fromDate(new Date("1/1/2200")),
                                            enteredGroup: Timestamp.now(),
                                            permissions: [{ AddRemoveMemersFromGroup: false, EditRemoveGroup: false, EditOthersPermissions: false, CreateRemoveGroupCategories: false, EditRemoveOtherTheirExpenses: false }]

                                        });
                                        addMember.then(() => {
                                            window.location.reload();
                                        });
                                    });
                                } catch (error) {
                                    searchBarMember.innerHTML = "Problem adding member" + error;
                                }
                            }
                            else {
                                try {
                                    await getMembersFromFirebase.forEach((member) => {
                                        updateDoc(doc(db, "Groups", groupId), { members: arrayUnion(member.userId) });
                                        const addMember = updateDoc(doc(db, "Groups", groupId, "Members", member.key), {
                                            membership: Timestamp.fromDate(new Date("1/1/2200")),
                                            enteredGroup: Timestamp.now()
                                        });
                                        addMember.then(() => {
                                            window.location.reload();
                                        });
                                    });
                                } catch (error) {
                                    searchBarMember.innerHTML = "Problem adding member membership" + error;
                                }
                            }
                        }
                    }
                } catch (error) {
                    searchBarMember.innerHTML = "Problem adding member" + error;
                }
            }
            else {
                searchBarMember.innerHTML = "You don't have the permissions to add members";
            }
        } catch (error) {
            
        }
    }

    function getCurrentUser() {
        if (auth.currentUser !== null) {
            setCurrentUser(auth.currentUser);
        }
    }

    async function addScannedMember(){
        const errorMessageScan = document.getElementsByClassName("errorAddScanned")[0];
       try {
           if (checkPermissions(Operation.AddRemoveMemersFromGroup)) {
               let allMembers = [];
               let userAlredyExists = false;
               let userExistsButMemberschipIsNotValid = false;
               let memberKey = "";

               //alle members van de huidige group ophalen
               const queryGroup = query(collection(db, "/Groups", groupId, "Members"));
               const queryGroupSnapshot = await getDocs(queryGroup);
               queryGroupSnapshot.forEach((doc) => {
                   // doc.data() is never undefined for query doc snapshots
                   //only users where the memberschip is greater than today
                   allMembers.push({ ...doc.data(), membership: new Date(doc.data().membership.seconds * 1000), enteredGroup: new Date(doc.data().enteredGroup.seconds * 1000), key: doc.id });
               });

               //checken naar het lidmaatschap van de user of de user al in de group zit
               allMembers.forEach((member) => {
                   if (member.uid === scannedUser.userId && new Date(member.membership) > new Date()) {
                       userAlredyExists = true;
                       errorMessageScan.innerHTML = "This user is already in this group";
                       document.getElementsByClassName("searchBarMember")[0].value = "";
                       return;
                   }
                   else if (member.uid === scannedUser.userId && new Date(member.membership) <= new Date()) {
                       userExistsButMemberschipIsNotValid = true;
                       memberKey = member.key;
                   }
               });

               if (userAlredyExists === false) {
                   if (!userExistsButMemberschipIsNotValid) {
                       try {
                           updateDoc(doc(db, "Groups", groupId), { members: arrayUnion(scannedUser.userId) });
                           const addMember = addDoc(collection(db, "Groups", groupId, "Members"), {
                               uid: scannedUser.userId,
                               membership: Timestamp.fromDate(new Date("1/1/2200")),
                               enteredGroup: Timestamp.now(),
                               permissions: [{ AddRemoveMemersFromGroup: false, EditRemoveGroup: false, EditOthersPermissions: false, CreateRemoveGroupCategories: false, EditRemoveOtherTheirExpenses: false }]
                           });
                           addMember.then(() => {
                               window.location.reload();
                           });
                       } catch (error) {
                           errorMessageScan.innerHTML = "Something went wrong: " + error;
                       }
                   }
                   else {
                       try {
                           updateDoc(doc(db, "Groups", groupId), { members: arrayUnion(scannedUser.userId) });
                           const addMember = updateDoc(doc(db, "Groups", groupId, "Members", memberKey), {
                               membership: Timestamp.fromDate(new Date("1/1/2200")),
                               enteredGroup: Timestamp.now()
                           });
                           addMember.then(() => {
                               window.location.reload();
                           });
                       } catch (error) {
                           errorMessageScan.innerHTML = "Something went wrong: " + error;
                       }
                   }
               }
           }
           else {
               errorMessageScan.innerHTML = "You don't have the permissions to add members";
           }
       } catch (error) {
           errorMessageScan.innerHTML = "A problem occured while adding the member: " + error;
       }
    }
}

export default ManagePeople;